import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AccountsTable from '@tcs/client-portal-representative/components/molecules/AccountsTable';
import useRepresentativeAccounts from '@tcs/client-portal-common/hooks/useRepresentativeAccounts';
import AccountsInfoPanel from '@tcs/client-portal-representative/components/molecules/AccountsInfoPanel';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import { AccountSearchResult } from '@tcs/client-portal-api/types/AccountSearchResult';
import Spinner from '@tcs/common/components/atoms/Spinner';
import orderBy from 'lodash/orderBy';

const AccountsOverview = () => {
  const nav = useNavigate();
  const [sortByField, setSortByField] = useState('accountStatus');
  const [sortDirection, setSortDirection] = useState('asc');
  const {
    claims: { clientPortalIdentity },
  } = useSession();
  const { data: accounts, loading } =
    useRepresentativeAccounts(clientPortalIdentity);

  if (loading) {
    return <Spinner />;
  }

  if (!accounts) return null;

  let orderedAccounts = accounts;

  const onClickAccountsTableRow = ({ id }: AccountSearchResult) => {
    nav(`/accounts/${id}`);
  };

  const onClickAccountsTableColumn = (id: string) => {
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  };

  if (sortDirection === 'asc') {
    orderedAccounts = orderBy(orderedAccounts, (a) => a[sortByField], ['asc']);
  }

  if (sortDirection === 'desc') {
    orderedAccounts = orderBy(orderedAccounts, (a) => a[sortByField], ['desc']);
  }

  return (
    <div>
      <AccountsInfoPanel accounts={accounts} />
      <AccountsTable
        accounts={orderedAccounts}
        onRowClick={onClickAccountsTableRow}
        onColumnClick={onClickAccountsTableColumn}
      />
    </div>
  );
};

export default AccountsOverview;
